import useMyWorkspace from './useMyWorkspace';
import { useMemo } from 'react';
import useWorkspaceById from './useWorkspaceById';

type IFun = typeof useMyWorkspace;
function useMachineTypesByWorkspaceId(
  id: string,
  arg1?: Parameters<IFun>[0],
  arg2?: Parameters<IFun>[1]
) {
  let response = useWorkspaceById(id, arg1, arg2);
  const responseMyWorkspace = useMyWorkspace(arg1, arg2);
  if (!id) {
    response = responseMyWorkspace;
  }
  const sorted = useMemo(
    () =>
      response.data?.machineTypes.slice().sort((a, b) =>
        a.name.localeCompare(b.name, undefined, {
          numeric: true,
          sensitivity: 'base',
        })
      ),
    [response.data?.machineTypes]
  );
  return { ...response, data: sorted };
}

export default useMachineTypesByWorkspaceId;
